import { IDownloadDiarioObraImagemUseCase } from "../../../presentation/useCases/read/download_diario_obra_imagem_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// DownloadDiarioObraImagemUseCase

export class DownloadDiarioObraImagemUseCase implements IDownloadDiarioObraImagemUseCase {
    constructor(private readonly repository: IDiarioObraRepository) { }

    async getDiarioObraImagemBlob(idDiarioObrasImagens: number): Promise<Blob> {
        const blob = await this.repository.downloadDiarioObraImagem(idDiarioObrasImagens);
        if (!blob) throw new Error("Falha ao buscar dados da imagem!");
        return blob;
    }

    async downloadDiarioObraImagem(idDiarioObrasImagens: number, nomeArquivo: string): Promise<void> {
        const blob = await this.getDiarioObraImagemBlob(idDiarioObrasImagens);

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", nomeArquivo);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    }
}
